import { createAction, props } from '@ngrx/store';

export const setGlobalVariable = createAction('[App] SetGlobalVariable',
    props<{variable: string, newValue: any}>()
);

export const refreshPage = createAction('[App] RefreshPage',
    props<any>()
);